/* global SgTrackingCore, sgData, jQuery */
import TaggedLogger from './debug/tagged-logger';

(function ($) {
  $.fn.shopgateSmartAppBanner = function (incomingOptions) {
    const logger = new TaggedLogger('SmartBanner', 'color: SeaGreen;');
    logger.info('Init started.');
    const SgTrackingCore = window.SgTrackingCore;

    const defaults = {
      cookieLifetime: 30, // Lifetime in days - default: 30 days
      additionalClass: null,
      useLocalStorage: true,
    };

    let options = incomingOptions || {};
    options = $.extend({}, defaults, options);

    // Make sure we always have a number here
    options.cookieLifetime = parseInt(options.cookieLifetime, 10);

    // Return if cookie lifetime is 0 or less
    if (options.cookieLifetime <= 0) {
      logger.warn('Invalid options for the smart banner functionality - please check them again');
      return $();
    }

    return this.each(function () {
      const that = $(this);

      if (options.useLocalStorage) {
        try {
          if (
            'localStorage' in window
            && typeof window.localStorage === 'object'
          ) {
            if (
              !localStorage.getItem('sg_hide_appbanner')
              && document.cookie.indexOf('sg_hide_appbanner') === -1
            ) {
              logger.info('Showing. No localStorage entry found');
              that.show();
              // No location, no event sent || localStorage is probably not used anyway
              if (that.data('location')) {
                SgTrackingCore.track.smartbanner({
                  eventAction: 'show',
                  eventLabel: that.data('location'),
                });
              }
            } else {
              logger.info('Not showing. LocalStorage entry found');
            }
          }
        } catch (e) {
          // No localStorage or safari in private mode, use cookie
          if (document.cookie.indexOf('sg_hide_appbanner') !== -1) {
            logger.info('Showing. Cookie not found.');
            that.show();
            SgTrackingCore.track.smartbanner({
              eventAction: 'show',
              eventLabel: that.data('location'),
            });
          }
        }

        that.find('.icon-close').click(() => {
          logger.info('User closed smartbanner. Saving the choice.');
          that.hide();
          // Send hide user interaction to tracker
          SgTrackingCore.track.smartbanner({
            eventAction: 'close',
            eventLabel: that.data('location'),
          });

          try {
            if (
              'localStorage' in window &&
              typeof window.localStorage === 'object'
            ) {
              localStorage.setItem('sg_hide_appbanner', 1);
              logger.info('Saved in localStorage.');
            }
          } catch (e) {
            // No localStorage or safari in private mode, use cookie
            logger.info('LocalStorage failed. Saving cookie.');
            /**
             *
             * @type {Date}
             */
            let a = new Date();
            a = new Date(a.getTime() + (1000 * 60 * 60 * 24 * options.cookieLifetime));
            document.cookie = `sg_hide_appbanner=1; expires=${ a.toGMTString() };`;
          }
        });
      } else {
        // Check if a cookie was set, then show banner
        if (document.cookie.indexOf('sg_hide_appbanner') === -1) {
          logger.info('No cookie found. Showing.');
          that.show();
          SgTrackingCore.track.smartbanner({
            eventAction: 'show',
            eventLabel: that.data('location'),
          });
        } else {
          logger.info('Cookie found. Aborting showing.');
        }

        // Set the cookie when close button was clicked
        that.find('.icon-close').click(() => {
          logger.info('User clicked hide. Saving choice to cookie.');
          that.hide();
          // Send hide user interaction to tracker
          SgTrackingCore.track.smartbanner({
            eventAction: 'close',
            eventLabel: that.data('location'),
          });

          /*
           If you change the following lines please make sure to check the code
           for jquery.shopgate-open-app.js aswell
           */
          let a = new Date();
          a = new Date(a.getTime() + (1000 * 60 * 60 * 24 * options.cookieLifetime));
          document.cookie = `sg_hide_appbanner=1; expires=${a.toGMTString()};`;
          logger.info('Cookie saved.');
        });
      }
    });
  };
}(jQuery));



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-smart-app-banner.js